module.exports = __webpack_public_path__ + "static/media/send.9196bd1c.svg";